import script from "./productLinkGroups.vue?vue&type=script&setup=true&lang=ts"
export * from "./productLinkGroups.vue?vue&type=script&setup=true&lang=ts"

import "./productLinkGroups.vue?vue&type=style&index=0&id=2de13083&lang=scss&scope=true"

const __exports__ = script;

export default __exports__